import { createNameContext } from '@showroomjs/ui';
import * as React from 'react';
export const ComponentMetaContext = createNameContext('ComponentDoc', undefined);
export const useComponentMeta = () => React.useContext(ComponentMetaContext);
export const isType = (prop, type) => prop.type.name === type ||
    (prop.type.name === 'enum' && prop.type.raw === type);
//# sourceMappingURL=component-props-context.js.map